<div class="container pb-13">
  <lib-web-shared-ui-page-header [data]="pageHeaderObj()" (emitPathUrl)="redirectTo($event)"></lib-web-shared-ui-page-header>
  <p class="font-size-20 mb-5">
    นโยบายการรับประกันยางชำรุด บาด บวม แตก 60 วัน เปลี่ยนฟรี สำหรับผลิตภัณฑ์ยางรถยนต์ TOYO และ TOYO TIRES มีเงื่อนไขและข้อปฏิบัติดังนี้
  </p>
  <lib-web-shared-ui-warranty-policy [data]="warrantyPolicyObj"></lib-web-shared-ui-warranty-policy>
</div>
